import { create } from 'zustand';
import { Character } from '../api/client';

interface CharacterState {
  characters: Character[];
  currentCharacter: Character | null;
  hasBootstrapped: boolean;
  error: string | null;

  setCharacters: (characters: Character[]) => void;
  setCurrentCharacter: (character: Character | null) => void;
  addCharacter: (character: Character) => void;
  updateCharacter: (updated: Character) => void;
  removeCharacter: (id: string) => void;
  clearCharacters: () => void;
  setBootstrapped: () => void;
  setError: (error: string | null) => void;
}

export const useCharacterStore = create<CharacterState>((set) => ({
  characters: [],
  currentCharacter: null,
  hasBootstrapped: false,
  error: null,

  setCharacters: (characters) => set({ characters }),
  setCurrentCharacter: (character) => set({ currentCharacter: character }),
  addCharacter: (character) =>
    set((state) => ({ characters: [...state.characters, character] })),
  updateCharacter: (updated) =>
    set((state) => ({
      characters: state.characters.map((c) =>
        c.id === updated.id ? updated : c
      ),
      currentCharacter: state.currentCharacter?.id === updated.id ? updated : state.currentCharacter,
    })),
  removeCharacter: (id) =>
    set((state) => ({
      characters: state.characters.filter((c) => c.id !== id),
      currentCharacter: state.currentCharacter?.id === id ? null : state.currentCharacter,
    })),
  clearCharacters: () => set({ characters: [], currentCharacter: null }),
  setBootstrapped: () => set({ hasBootstrapped: true }),
  setError: (error) => set({ error }),
}));
